// -request.js
import axios from 'axios'
//1.利用axios对象的方法create，去创建一个axios实际
//2.request就是axios，只不过稍微配置一下
const requests = axios.create({
    //配置对象
    //基础路径，发请求的时候，路径当中出现api
    baseURL:'/board',
    //代表请求超时的时间5s
    timeout:5*1000,
    withCredentials: true
})
console.log("请求拦截器------------");
console.log(requests);

//请求拦截器：在发请发之前，请求拦截器可以检测到，可以在请求发出去之前做一些事情
 axios.interceptors.request.use(
    config => {
        if(config.url == 'https://qiliangong.oss-cn-shenzhen.aliyuncs.com'){
            delete config.headers.token;
            return config
        }else{
            if (localStorage.getItem('token')) {
                let token = localStorage.getItem('token')
                console.log('获取token');
                console.log(token);
                config.headers['token'] = token
                return config
            }else{
                config.headers['token'] = ''
                return config
            }
        }
    },
    error => {
        console.log("errerrrerrerrerr-------------");
        return Promise.reject(error)
    }
)
//响应拦截器
axios.interceptors.response.use((res)=>{
   
    return res

},()=>{
    return Promise.reject(new Error('faile'))
})


export default axios
